import Vue from 'vue'

Vue.directive('dialogDrag', {
  bind (el, binding, vnode, oldVnode) {
    const dialogHeaderEl = el.querySelector('.el-dialog__header')
    const dragDom = el.querySelector('.el-dialog')
    //dialogHeaderEl.style.cursor = 'move';
    dialogHeaderEl.style.cssText += ';cursor:move;'
    dragDom.style.cssText += ';top:0px;'
    // 获取原有属性 ie dom元素.currentStyle 火狐谷歌 window.getComputedStyle(dom元素, null);
    const sty = (function () {
      if (window.document.currentStyle) {
        return (dom, attr) => dom.currentStyle[attr]
      } else {
        return (dom, attr) => getComputedStyle(dom, false)[attr]
      }
    })()
    dialogHeaderEl.onmousedown = (e) => {
      const disX = e.clientX - dialogHeaderEl.offsetLeft
      const disY = e.clientY - dialogHeaderEl.offsetTop
      const screenWidth = document.body.clientWidth // body当前宽度
      const screenHeight = document.documentElement.clientHeight // 可见区域高度(应为body高度，可某些环境下无法获取)
      const dragDomWidth = dragDom.offsetWidth // 对话框宽度
      const dragDomheight = dragDom.offsetHeight // 对话框高度
      const minDragDomLeft = dragDom.offsetLeft
      const maxDragDomLeft = screenWidth - dragDom.offsetLeft - dragDomWidth
      const minDragDomTop = dragDom.offsetTop
      const maxDragDomTop = screenHeight - dragDom.offsetTop - dragDomheight
      // 获取到的值带px 正则匹配替换
      let styL = sty(dragDom, 'left')
      let styT = sty(dragDom, 'top')
      // 注意在ie中 第一次获取到的值为组件自带50% 移动之后赋值为px
      if (styL.includes('%')) {
        styL = +document.body.clientWidth * (+styL.replace(/\%/g, '') / 100)
        styT = +document.body.clientHeight * (+styT.replace(/\%/g, '') / 100)
      } else {
        styL = +styL.replace(/\px/g, '')
        styT = +styT.replace(/\px/g, '')
      }
      document.onmousemove = function (e) {
        // 通过事件委托，计算移动的距离
        let left = e.clientX - disX
        let top = e.clientY - disY
        // 边界处理
        if (-(left) > minDragDomLeft) {
          left = -(minDragDomLeft)
        } else if (left > maxDragDomLeft) {
          left = maxDragDomLeft
        }
        if (-(top) > minDragDomTop) {
          top = -(minDragDomTop)
        } else if (top > maxDragDomTop) {
          top = maxDragDomTop
        }
        // 移动当前元素
        dragDom.style.cssText += `;left:${left + styL}px;top:${top + styT}px;`
      }
      document.onmouseup = function (e) {
        document.onmousemove = null
        document.onmouseup = null
      }
    }
  }
})

Vue.directive('drag', {
  bind (el) {
    // 缓存 clientX clientY 的对象: 用于判断是点击事件还是移动事件
    const clientOffset = {}
    el.onmousedown = e => {
      const disX = e.clientX - el.offsetLeft
      const disY = e.clientY - el.offsetTop
      clientOffset.clientX = e.clientX
      clientOffset.clientY = e.clientY
      document.onmousemove = e => {
        const left = e.clientX - disX
        const top = e.clientY - disY
        el.style.left = left + 'px'
        el.style.top = top + 'px'
        // el 距离顶部的距离
        const dragDivTop = window.innerHeight - el.getBoundingClientRect().height
        // el 距离左部的距离
        const dragDivLeft = window.innerWidth - el.getBoundingClientRect().width
        // 边界判断处理
        // 2、超出顶部处理
        if (el.getBoundingClientRect().top <= 0) {
          el.style.top = '0px'
        }
        // 3、超出底部处理
        if (el.getBoundingClientRect().top >= dragDivTop) {
          el.style.top = dragDivTop + 'px'
        }
        // 4、超出右边边界区域处理
        if (el.getBoundingClientRect().left >= dragDivLeft) {
          el.style.left = dragDivLeft + 'px'
        }
        // 5、超出左边边界区域处理
        if (el.getBoundingClientRect().left <= 0) {
          el.style.left = '0px'
        }
      }
      document.onmouseup = () => {
        document.onmousemove = null
        document.onmouseup = null
      }
    }
    // 绑定鼠标松开事件
    el.addEventListener('mouseup', (event) => {
      const clientX = event.clientX
      const clientY = event.clientY
      if (clientX === clientOffset.clientX && clientY === clientOffset.clientY) {
        return false
        // console.log('click 事件');
      } else {
        return false
        // console.log('drag 事件');
      }
    })
  }
})
